
import { useUnifiedDashboardData } from './useUnifiedDashboardData';
import type { DashboardStats, UniqueFilterValues } from './useUnifiedDashboardData';

export type { DashboardStats, UniqueFilterValues };

export const useEntraramUltimaSemanaData = () => {
  return useUnifiedDashboardData('entraram-ultima-semana');
};
